var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('buy-button',_vm._g({attrs:{"good":_vm.good},scopedSlots:_vm._u([{key:"default",fn:function(slotData){return [_vm._t("default",null,null,slotData)]}}],null,true)},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }